export default t => [
  { title: t('property.steps.search.title'), description: t('property.steps.search.description') },
  { title: t('property.steps.link.title'), description: t('property.steps.link.description') },
  { title: t('property.steps.edit.title'), description: t('property.steps.edit.description') },
];
